﻿import Vue from "vue";
import Component from "vue-class-component";
import common from "../../common";
import context_ from "../context";
import HotEditableFormLoader_ from "./hotEditable/HotEditableFormLoader";


const context = require("../context") as typeof context_;
// const HotEditableFormLoader = require("./hotEditable/HotEditableFormLoader") as HotEditableFormLoader_;

@Component
class MainMenuVue extends Vue {
    culture?: string;
    isVisibleLanguage?: boolean;
    _initCulture = null as string | null;
    _onCultureChangeCallback = null as ((culture: common.Cultures) => void) | null;

    beforeCreate() {
        const rootId = (this as any).$initialData.vueElId as string;
        HotEditableFormLoader_.prepareComponentsMarkupFromTarget(false, false, rootId);//.loadComponentsFromParent(this);

        this._initCulture = (this as any).$initialData.currentCulture as common.Cultures;
        this.$options.el = '#' + rootId;

        // this.formManager = new HotEditableFormManager_(this, (this as any).$initialData.formName as string | null, {
        //     loadFormModeFromUrl: (this as any).$initialData.loadFormModeFromUrl !== false,
        //     embeddedContentModels: (((this as any).$initialData.embeddedContentModels || []) as common.IEmbeddedContentModel[]).sort((a, b) => {
        //         return a.order - b.order;
        //     })
        // });
        // this.shared = new SharedFormManager_(this.formManager);
    }

    // destroyComponents() {
    //     this.formManager.destroyComponents();
    //     this.formManager = null;//DESTROY (TEST)
    //     return this;
    // }

    data() {
        const c = this._initCulture ? common.Cultures[this._initCulture as common.Cultures] ?? (() => { throw "La culture '" + this._initCulture + "' n'est pas supportée."; })() : common.Cultures.fr;
        const o = {
            culture: c,
            isVisibleLanguage: true
        };
        return o;
    }

    created() {

    }

    mounted() {
    }
    setOnCultureChangeCallback(callback: (culture: common.Cultures) => void) {
        this._onCultureChangeCallback = callback || (function () { throw "L'argument 'callback' est NULL."; })();
        return this;
    }
    onToggleCulture(event: Event) {
        event.preventDefault();
        this.toggleCulture();
    }
    toggleCulture() {
        this.updateCulture(this.culture === common.Cultures.en ? common.Cultures.fr : common.Cultures.en);
        return this;
    }
    /** Sequence: thisVue.updateCulture > callbak(post API & wait updatedCulture) > thisVue.setCulture */
    updateCulture(cultureName?: string) {
        cultureName = (cultureName || '').trim();
        const c = cultureName
            ? common.Cultures[cultureName as common.Cultures] || (function () { throw "La culture '" + cultureName + "' n'existe pas."; })()
            : common.Cultures.fr
        if (!this._onCultureChangeCallback)
            throw "Aucun callback configuré pour lors du changement de culture.";
        this._onCultureChangeCallback(c);
        return this;
    }
    setCutlure(culture: common.Cultures) {
        if (!culture)
            throw "L'argument 'callback' est NULL.";
        if (!common.Cultures[culture])
            throw "La culture '" + culture + "' n'existe pas.";
        this.culture = culture;
        return this;
    }
    /** Sequence: thisVue.updateCulture > update the culture context name > callbak(post API & wait updatedCulture) > thisVue.setCulture */
    refreshCultureFromContext() {
        this.setCutlure(context.culture.get());
        return this;
    }
    showCultureToggleButton(value?: boolean) {
        value = value !== false;
        this.isVisibleLanguage = value;
    }
}

export = MainMenuVue;